import {
    FETCH_COACH_INFO,
    FETCH_COACH_INFO_SUCCESS,
    FETCH_COACH_INFO_FAILED,
    FETCHING_COACH_INFO
} from '../../actions/ActionTypes.js';

const fetchCoachInfoSuccess = (state, action) => {
    return {
        ...state,
        coachInfo: action.atpCoachInfo
    };
};

const fetchCoachInfoFail = (state, action) => {
    return {
        ...state,
        error: action.error
    };
};

export const getCoachInfo = (state) => {
    return state.atpCoachInfo.coachInfo;
};

const handlers = {
    [FETCH_COACH_INFO_SUCCESS]: fetchCoachInfoSuccess,
    [FETCH_COACH_INFO_FAILED]: fetchCoachInfoFail
};

export default function atpCoachInfo(state = {}, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export function fetchCoachInfo(contentID, locale) {
    return {
        type: FETCH_COACH_INFO,
        payload: {
            contentID,
            locale
        }
    };
}
